import "./App.css";
import Layout from "./compononts/layout/Layout";

function App() {
  return <Layout />;
}

export default App;
